/** @type {import('../schema').ProcessDefinition} */
const gestionUnidades = {
  id: "gestion-unidades",
  name: "Gestión de unidades / residentes",
  category: "personas",
  outcome:
    "El Administrador visualiza y edita unidades, asigna ocupantes y consulta el histórico de tenencias.",
  trigger: "El Administrador abre Residentes y entra a una unidad.",
  actors: ["Administrador", "Residente", "Sistema"],
  status: "COMPLETO",
  description:
    "Gestión de las unidades del edificio: listado con estado de activación, detalle con contactos del ocupante, timeline de tenencias (vigente y cerradas), edición de datos y bloqueo de acceso de un saliente.",
  lanes: [
    { id: "admin", actor: "Administrador" },
    { id: "sys", actor: "Sistema" },
    { id: "res", actor: "Residente" },
  ],
  steps: [
    { id: "s1", laneId: "admin", type: "start", label: "Abre Residentes", description: "El admin entra a la pantalla de residentes del edificio.", evidence: "src/screens/admin/Residentes.jsx" },
    { id: "s2", laneId: "sys", type: "task", label: "Lista las unidades", description: "Muestra número, piso, propietario/inquilino y estado de activación.", evidence: "src/screens/admin/Residentes.jsx" },
    { id: "s3", laneId: "admin", type: "task", label: "Abre el detalle de la unidad", description: "Datos de la unidad y contactos del ocupante.", evidence: "src/screens/admin/UnidadDetalle.jsx" },
    { id: "s4", laneId: "sys", type: "document", label: "Histórico de tenencias", description: "Timeline de occupancies (vigente y cerradas). Si hay ocupante legado sin occupancy, se reconstruye desde apartments." },
    { id: "s5", laneId: "admin", type: "decision", label: "¿Vacía u ocupada?" },
    { id: "s6", laneId: "admin", type: "task", label: "Edita datos de la unidad o contactos", description: "Edita datos de la unidad o los contactos del ocupante; el sistema persiste (apartments.owner/tenant denormalizado).", evidence: "src/screens/admin/UnidadDetalle.jsx" },
    { id: "s7", laneId: "res", type: "task", label: "Saliente con acceso de solo lectura", description: "El ocupante saliente conserva su histórico hasta que se revoque el acceso." },
    { id: "s8", laneId: "admin", type: "decision", label: "¿Bloquear acceso del saliente?" },
    { id: "s9", laneId: "admin", type: "task", label: "Revoca el acceso (accessBlocked)", description: "Sobre una tenencia cerrada, marca accessBlocked para revocar el acceso del saliente." },
    { id: "s10", laneId: "sys", type: "end", label: "Unidad actualizada", description: "Datos de unidad, occupancies y accessBlocked persistidos." },
  ],
  transitions: [
    { from: "s1", to: "s2" },
    { from: "s2", to: "s3" },
    { from: "s3", to: "s4" },
    { from: "s4", to: "s5" },
    { from: "s5", to: "s6", label: "ocupada" },
    { from: "s5", to: "s10", label: "vacía" },
    { from: "s6", to: "s7" },
    { from: "s7", to: "s8" },
    { from: "s8", to: "s9", label: "sí" },
    { from: "s8", to: "s10", label: "no" },
    { from: "s9", to: "s10" },
  ],
};

export default gestionUnidades;
